import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const localizeInit = () => {
    i18next
        .use(LanguageDetector)
        .init({
            detection: {
                order: ['querystring', /* 'cookie', 'localStorage', 'sessionStorage',*/ 'navigator', 'htmlTag']
            },
            supportedLngs: ['de', 'en', 'fr', 'ja', 'ko', 'zh-CN', 'tr'],
            fallbackLng: 'en',
            resources: {
                de: {
                    translation: {
                        // File menu
                        'file': 'Datei',
                        'file.new': 'Neu',
                        'file.open': 'Öffnen',
                        'file.import': 'Importieren...',
                        'file.load-all-data': 'PLY-Daten vollständig laden',
                        'file.save': 'Speichern',
                        'file.save-as': 'Speichern als...',
                        'file.publish': 'Veröffentlichen...',
                        'file.export': 'Exportieren',
                        'file.export.splat': 'Splat',
                        'file.export.viewer': 'Viewer App...',
                        'download.reference.pdf': 'Referenz-PDF herunterladen',

                        // Render menu
                        'render': 'Rendern',
                        'render.image': 'Bild...',
                        'render.video': 'Video...',
                        'render.ok': 'Rendern',
                        'render.cancel': 'Abbrechen',

                        // Selection menu
                        'select': 'Auswahl',
                        'select.all': 'Alles',
                        'select.none': 'Aufheben',
                        'select.invert': 'Invertieren',
                        'select.lock': 'Selektion sperren',
                        'select.unlock': 'Sperre aufheben',
                        'select.delete': 'Selektion aufheben',
                        'select.reset': 'Splats zurücksetzen',
                        'select.duplicate': 'Duplizieren',
                        'select.separate': 'Separieren',

                        // Help menu
                        'help': 'Hilfe',
                        'help.shortcuts': 'Tastaturkürzel',
                        'help.user-guide': 'Handbuch',
                        'help.log-issue': 'Problem melden',
                        'help.github-repo': 'GitHub Repository',
                        'help.basics-video': 'Grundlagen Video',
                        'help.discord': 'Discord Server',
                        'help.forum': 'Forum',
                        'help.about': 'Über Biligoba Scene Forensics',

                        // Modes
                        'mode.centers': 'Punkt Modus',
                        'mode.rings': 'Ring Modus',

                        // Scene panel
                        'scene-manager': 'SZENEN MANAGER',
                        'transform': 'TRANSFORMATION',
                        'position': 'Position',
                        'rotation': 'Rotation',
                        'scale': 'Skalierung',

                        // Options panel
                        'options': 'ANSICHTS OPTIONEN',
                        'options.colors': 'Farben',
                        'options.bg-color': 'Hintergrundfarbe',
                        'options.selected-color': 'Selektierte Farbe',
                        'options.unselected-color': 'Nicht selektierte Farbe',
                        'options.locked-color': 'Gesperrte Farbe',
                        'options.fov': 'Sichtfeld (FoV)',
                        'options.sh-bands': 'SH Bänder',
                        'options.centers-size': 'Punktgrößen',
                        'options.outline-selection': 'Umriss Selektion',
                        'options.show-grid': 'Raster anzeigen',
                        'options.show-bound': 'Objektbox anzeigen',
                        'options.camera-fly-speed': 'Kamera Geschwindigkeit',
                        'options.high-precision': 'Hohe Qualität',

                        // Camera panel
                        'camera': 'KAMERA POSEN',
                        'camera.add-pose': 'Pose hinzufügen',
                        'camera.prev-pose': 'Vorherige Pose',
                        'camera.next-pose': 'Nächste Pose',
                        'camera.play-poses': 'Posen abspielen',
                        'camera.clear-poses': 'Posen leeren',

                        // Color panel
                        'colors': 'FARBE',
                        'colors.tint': 'Färbung',
                        'colors.temperature': 'Temperatur',
                        'colors.saturation': 'Sättigung',
                        'colors.brightness': 'Helligkeit',
                        'colors.blackPoint': 'Schwarzpunkt',
                        'colors.whitePoint': 'Weißpunkt',
                        'colors.transparency': 'Transparenz',
                        'colors.reset': 'Zurücksetzen',

                        // Data panel
                        'data': 'SPLAT DATEN',
                        'data.distance': 'Entfernung',
                        'data.volume': 'Volumen',
                        'data.surface-area': 'Oberfläche',
                        'data.scale-x': 'Größe X',
                        'data.scale-y': 'Größe Y',
                        'data.scale-z': 'Größe Z',
                        'data.red': 'Rot',
                        'data.green': 'Grün',
                        'data.blue': 'Blau',
                        'data.opacity': 'Deckkraft',
                        'data.hue': 'Farbe',
                        'data.saturation': 'Sättigung',
                        'data.value': 'Helligkeit',
                        'data.log-scale': 'Logarithmische Skala',
                        'data.totals': 'Summe',
                        'data.totals.splats': 'Splats',
                        'data.totals.selected': 'Selektiert',
                        'data.totals.locked': 'Gesperrt',
                        'data.totals.deleted': 'Gelöscht',

                        // Shortcuts panel
                        'shortcuts.title': 'TASTATURKÜRZEL',
                        'shortcuts.movement': 'BEWEGUNG',
                        'shortcuts.move-forward': 'Vorwärts bewegen',
                        'shortcuts.move-backward': 'Rückwärts bewegen',
                        'shortcuts.move-left': 'Nach links bewegen',
                        'shortcuts.move-right': 'Nach rechts bewegen',
                        'shortcuts.move-up': 'Nach oben bewegen',
                        'shortcuts.move-down': 'Nach unten bewegen',
                        'shortcuts.move-fast': 'Schnell bewegen (10x)',
                        'shortcuts.move-slow': 'Langsam bewegen (0.1x)',
                        'shortcuts.camera': 'KAMERA',
                        'shortcuts.zoom': 'Zoomen',
                        'shortcuts.pan': 'Verschieben',
                        'shortcuts.zoom-fast': 'Schnell zoomen',
                        'shortcuts.orbit': 'Kamera drehen',
                        'shortcuts.focus-point': 'Fokuspunkt setzen',
                        'shortcuts.other': 'WEITERE',
                        'shortcuts.toggle-camera-mode': 'Kameramodus umschalten',
                        'shortcuts.toggle-grid': 'Rasteranzeige umschalten',
                        'shortcuts.toggle-gizmo-coordinate-space': 'Gizmoanzeige umschalten',

                        // Popup
                        'popup.ok': 'OK',
                        'popup.cancel': 'Abbrechen',
                        'popup.yes': 'Ja',
                        'popup.no': 'Nein',
                        'popup.error': 'FEHLER',
                        'popup.error-loading': 'FEHLER BEIM LADEN DER DATEI',
                        'popup.drop-files': 'Bitte Dateien und Ordner ablegen',
                        'popup.copy-to-clipboard': 'Link in die Zwischenablage kopieren',

                        // Right toolbar
                        'tooltip.splat-mode': 'Splat Modus ( M )',
                        'tooltip.show-hide': 'Anzeigen/Ausplenden Splats ( Leertaste )',
                        'tooltip.frame-selection': 'Rechteckselektion ( F )',
                        'tooltip.camera-reset': 'Kamera zurücksetzen',
                        'tooltip.color-panel': 'Farben',
                        'tooltip.view-options': 'Anzeige Optionen',
                        'tooltip.clickable-zones': 'Beweise',
                        'tooltip.evidence-list': 'Beweis-Liste',
                        'tooltip.show-associated-picture': 'Zugehöriges Bild anzeigen',

                        // Bottom toolbar
                        'tooltip.undo': 'Rückgängig ( Strg + Z )',
                        'tooltip.redo': 'Wiederholen ( Strg + Shift + Z )',
                        'tooltip.picker': 'Einzelselektion ( R )',
                        'tooltip.polygon': 'Polygonselektion ( P )',
                        'tooltip.brush': 'Pinselselektion ( B )',
                        'tooltip.sphere': 'Kugelselektion',
                        'tooltip.box': 'Kastenselektion',
                        'tooltip.translate': 'Verschieben ( 1 )',
                        'tooltip.rotate': 'Drehen ( 2 )',
                        'tooltip.scale': 'Skalieren ( 3 )',
                        'tooltip.local-space': 'Gizmo in local-space',
                        'tooltip.bound-center': 'Mittelpunkt verwenden',
                        'tooltip.measure-distance': 'Entfernung messen ( M )',

                        // Measure tool
                        'measure.distance': 'Entfernung (m):',

                        // Viewer Export
                        'export.header': 'EXPORTIEREN',
                        'export.type': 'Export Typ',
                        'export.html': 'HTML',
                        'export.package': 'ZIP Paket',
                        'export.sh-bands': 'SH Bänder',
                        'export.start-position': 'Start Position',
                        'export.default': 'Standard',
                        'export.viewport': 'Aktuelle Ansicht',
                        'export.pose-camera': '1. Kamera Pose',
                        'export.fov': 'Sichtfeld (FoV)',
                        'export.background-color': 'Hintergrund',
                        'export.filename': 'Dateiname',
                        'export.animation': 'Animation',
                        'export.animation-none': 'Keine',
                        'export.animation-track': 'Track',
                        'export.ply-compress': 'PLY komprimieren',
                        'export.splats-select': 'Splats',
                        'export.splats-select.all': 'Alle Splats',
                        'export.format': 'Format',
                        'export.format-compressed-ply': 'Komprimiertes PLY',
                        'export.format-sogs': 'SOGS',

                        // Cursor
                        'cursor.click-to-copy': 'Klicken zum kopieren',
                        'cursor.copied': 'Kopiert!',

                        // Doc
                        'doc.reset': 'SZENE ZURÜCKSETZEN',
                        'doc.unsaved-message': 'Sie haben ungespeicherte Änderungen. Möchten Sie die Szene wirklich zurücksetzen?',
                        'doc.reset-message': 'Möchten Sie die Szene wirklich zurücksetzen?',
                        'doc.save-failed': 'FEHLGESCHLAGEN ZU SPEICHERN',
                        'doc.load-failed': 'FEHLGESCHLAGEN ZU LADEN',

                        // Publish Settings Dialog
                        'publish.header': 'VERÖFFENTLICHEN EINSTELLUNGEN',
                        'publish.ok': 'Veröffentlichen',
                        'publish.cancel': 'Abbrechen',
                        'publish.title': 'Titel',
                        'publish.description': 'Beschreibung',
                        'publish.listed': 'Aufgelistet',
                        'publish.failed': 'VERÖFFENTLICHEN FEHLGESCHLAGEN',
                        'publish.please-try-again': 'Bitte versuchen Sie es später erneut.',
                        'publish.succeeded': 'VERÖFFENTLICHEN ERFOLGREICH',
                        'publish.message': 'Verwenden Sie den Link unten, um auf Ihre Szene zuzugreifen.',
                        'publish.please-log-in': 'Das Veröffentlichen in PlayCanvas erfordert ein Benutzerkonto. Bitte melden Sie sich an und versuchen Sie es erneut.',

                        // Video Settings Dialog
                        'video.header': 'VIDEO EINSTELLUNGEN',
                        'video.resolution': 'Auflösung',
                        'video.frameRate': 'Bildrate',
                        'video.bitrate': 'Bitrate',
                        'video.portrait': 'Hochformat',
                        'video.transparentBg': 'Transparenter Hintergrund',
                        'video.showDebug': 'Debug-Überlagerungen anzeigen',

                        // Timeline
                        'timeline.prev-key': 'Zur vorherigen Keyframe springen',
                        'timeline.play': 'Abspielen/Stoppen',
                        'timeline.next-key': 'Zur nächsten Keyframe springen',
                        'timeline.add-key': 'Key hinzufügen',
                        'timeline.remove-key': 'Key entfernen',
                        'timeline.frame-rate': 'Bildrate',
                        'timeline.total-frames': 'Gesamtanzahl der Frames',

                        // Image Viewer Panel
                        'image-viewer': 'Bildbetrachter',

                        // Image Import
                        'image.import': 'Bilder importieren',
                        'image-config.import': 'Bildkonfiguration importieren',
                        'file.import.blg': 'BLGS importieren',
                        // User
                        'user.login': 'Anmelden',
                        'user.logout': 'Abmelden',
                        'user.scenes': 'Einsatzorte',
                        'user.account': 'Konto',
                        'user.email': 'E-Mail/Benutzername',
                        'user.password': 'Passwort',
                        'user.invalid-credentials': 'Ungültige E-Mail-Adresse oder Passwort.',
                        'user.login-failed': 'Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
                        'user.scenes.header': 'FERNE EINSATZORTE',
                        'user.scenes.upload': 'Neuen Einsatzort hochladen',
                        'user.scenes.download': 'Herunterladen',
                        'user.upload.header': 'EINSATZORT HOCHLADEN',
                        'user.upload.photos': 'Fotos',
                        'user.upload.video': 'Video',
                        'user.upload.photos-desc': 'Wählen Sie mehrere Fotos für die Rekonstruktion aus.',
                        'user.upload.video-desc': 'Wählen Sie eine einzelne Videodatei für die Rekonstruktion aus.',
                        'user.upload.drop-files': 'Dateien hier ablegen oder zum Auswählen klicken',
                        'user.upload.pick-files': 'Dateien auswählen',
                        'user.upload.project-name': 'Projektname',
                        'user.upload.error-no-files': 'Bitte wählen Sie mindestens eine Datei aus.',
                        'user.upload.error-no-name': 'Bitte geben Sie einen Projektnamen ein.',
                        'user.upload.error-mixed': 'Fotos und Videos können nicht zusammen hochgeladen werden.',
                        'user.upload.error-multiple-videos': 'Es kann nur ein Video gleichzeitig hochgeladen werden.'

                    }
                },
                en: {
                    translation: {
                        // File menu
                        'file': 'File',
                        'file.new': 'New',
                        'file.open': 'Open',
                        'file.import': 'Import...',
                        'file.load-all-data': 'Load all PLY data',
                        'file.save': 'Save',
                        'file.save-as': 'Save As...',
                        'file.publish': 'Publish...',
                        'file.export': 'Export',
                        'file.export.ply': 'PLY (.ply)',
                        'file.export.splat': 'Splat file (.splat)',
                        'file.export.viewer': 'Viewer App...',
                        'download.reference.pdf': 'Download Reference PDF',

                        // Render menu
                        'render': 'Render',
                        'render.image': 'Image...',
                        'render.video': 'Video...',
                        'render.ok': 'Render',
                        'render.cancel': 'Cancel',
                        'render.render-video': 'Render Video',
                        'render.rendering': 'Rendering Frames...',

                        // Selection menu
                        'select': 'Select',
                        'select.all': 'All',
                        'select.none': 'None',
                        'select.invert': 'Invert',
                        'select.lock': 'Lock Selection',
                        'select.unlock': 'Unlock All',
                        'select.delete': 'Delete Selection',
                        'select.reset': 'Reset Splat',
                        'select.duplicate': 'Duplicate',
                        'select.separate': 'Separate',

                        // Help menu
                        'help': 'Help',
                        'help.shortcuts': 'Keyboard Shortcuts',
                        'help.user-guide': 'User Guide',
                        'help.log-issue': 'Log an Issue',
                        'help.github-repo': 'GitHub Repo',
                        'help.basics-video': 'Basics Video',
                        'help.discord': 'Discord Server',
                        'help.forum': 'Forum',
                        'help.about': 'About Biligoba Scene Forensics',

                        // Modes
                        'mode.centers': 'Centers Mode',
                        'mode.rings': 'Rings Mode',

                        // Scene panel
                        'scene-manager': 'SCENE MANAGER',
                        'transform': 'TRANSFORM',
                        'position': 'Position',
                        'rotation': 'Rotation',
                        'scale': 'Scale',

                        // Options panel
                        'options': 'VIEW OPTIONS',
                        'options.colors': 'Colors',
                        'options.bg-color': 'Background Color',
                        'options.selected-color': 'Selected Color',
                        'options.unselected-color': 'Unselected Color',
                        'options.locked-color': 'Locked Color',
                        'options.fov': 'Field of View',
                        'options.sh-bands': 'SH Bands',
                        'options.centers-size': 'Centers Size',
                        'options.outline-selection': 'Outline Selection',
                        'options.show-grid': 'Show Grid',
                        'options.show-bound': 'Show Bound',
                        'options.camera-fly-speed': 'Fly Speed',
                        'options.tonemapping': 'Tonemapping',
                        'options.tonemapping-none': 'None',
                        'options.tonemapping-linear': 'Linear',
                        'options.tonemapping-neutral': 'Neutral',
                        'options.tonemapping-aces': 'ACES',
                        'options.tonemapping-aces2': 'ACES2',
                        'options.tonemapping-filmic': 'Filmic',
                        'options.tonemapping-hejl': 'Hejl',
                        'options.high-precision': 'High Quality',

                        // Camera panel
                        'camera': 'CAMERA POSES',
                        'camera.add-pose': 'Add Pose',
                        'camera.prev-pose': 'Previous Pose',
                        'camera.next-pose': 'Next Pose',
                        'camera.play-poses': 'Play Poses',
                        'camera.clear-poses': 'Clear Poses',

                        // Color panel
                        'colors': 'COLORS',
                        'colors.tint': 'Tint',
                        'colors.temperature': 'Temperature',
                        'colors.saturation': 'Saturation',
                        'colors.brightness': 'Brightness',
                        'colors.blackPoint': 'Black Point',
                        'colors.whitePoint': 'White Point',
                        'colors.transparency': 'Transparency',
                        'colors.reset': 'Reset',

                        // Data panel
                        'data': 'SPLAT DATA',
                        'data.distance': 'Distance',
                        'data.volume': 'Volume',
                        'data.surface-area': 'Surface Area',
                        'data.scale-x': 'Scale X',
                        'data.scale-y': 'Scale Y',
                        'data.scale-z': 'Scale Z',
                        'data.red': 'Red',
                        'data.green': 'Green',
                        'data.blue': 'Blue',
                        'data.opacity': 'Opacity',
                        'data.hue': 'Hue',
                        'data.saturation': 'Saturation',
                        'data.value': 'Value',
                        'data.log-scale': 'Log Scale',
                        'data.totals': 'Totals',
                        'data.totals.splats': 'Splats',
                        'data.totals.selected': 'Selected',
                        'data.totals.locked': 'Locked',
                        'data.totals.deleted': 'Deleted',

                        // Shortcuts panel
                        'shortcuts.title': 'KEYBOARD SHORTCUTS',
                        'shortcuts.movement': 'MOVEMENT',
                        'shortcuts.move-forward': 'Move Forward',
                        'shortcuts.move-backward': 'Move Backward',
                        'shortcuts.move-left': 'Move Left',
                        'shortcuts.move-right': 'Move Right',
                        'shortcuts.move-up': 'Move Up',
                        'shortcuts.move-down': 'Move Down',
                        'shortcuts.move-fast': 'Move Fast (10x)',
                        'shortcuts.move-slow': 'Move Slow (0.1x)',
                        'shortcuts.camera': 'CAMERA',
                        'shortcuts.zoom': 'Zoom',
                        'shortcuts.pan': 'Pan',
                        'shortcuts.zoom-fast': 'Zoom Fast',
                        'shortcuts.orbit': 'Orbit Camera',
                        'shortcuts.focus-point': 'Set Focus Point',
                        'shortcuts.other': 'OTHER',
                        'shortcuts.toggle-camera-mode': 'Toggle Camera Mode',
                        'shortcuts.toggle-grid': 'Toggle Grid',
                        'shortcuts.toggle-gizmo-coordinate-space': 'Toggle Gizmo Coordinate Space',

                        // Popup
                        'popup.ok': 'OK',
                        'popup.cancel': 'Cancel',
                        'popup.yes': 'Yes',
                        'popup.no': 'No',
                        'popup.error': 'ERROR',
                        'popup.error-loading': 'ERROR LOADING FILE',
                        'popup.drop-files': 'Please drop files and folders',
                        'popup.copy-to-clipboard': 'Copy link to clipboard',

                        // Right toolbar
                        'tooltip.splat-mode': 'Splat Mode ( M )',
                        'tooltip.show-hide': 'Show/Hide Splats ( Space )',
                        'tooltip.frame-selection': 'Frame Selection ( F )',
                        'tooltip.camera-reset': 'Reset Camera',
                        'tooltip.color-panel': 'Colors',
                        'tooltip.view-options': 'View Options',
                        'tooltip.clickable-zones': 'Evidence',
                        'tooltip.evidence-list': 'Evidence List',
                        'tooltip.show-associated-picture': 'Show Associated Picture',

                        // Bottom toolbar
                        'tooltip.undo': 'Undo ( Ctrl + Z )',
                        'tooltip.redo': 'Redo ( Ctrl + Shift + Z )',
                        'tooltip.picker': 'Picker Select ( R )',
                        'tooltip.polygon': 'Polygon Select ( P )',
                        'tooltip.brush': 'Brush Select ( B )',
                        'tooltip.sphere': 'Sphere Select',
                        'tooltip.box': 'Box Select',
                        'tooltip.translate': 'Translate ( 1 )',
                        'tooltip.rotate': 'Rotate ( 2 )',
                        'tooltip.scale': 'Scale ( 3 )',
                        'tooltip.local-space': 'Use Local Orientation',
                        'tooltip.bound-center': 'Use Bound Center',
                        'tooltip.measure-distance': 'Measure Distance ( M )',

                        // Measure tool
                        'measure.distance': 'Distance (m):',

                        // Viewer Export
                        'export.header': 'EXPORT',
                        'export.type': 'Export Type',
                        'export.html': 'HTML',
                        'export.package': 'ZIP Package',
                        'export.sh-bands': 'SH Bands',
                        'export.start-position': 'Start Position',
                        'export.default': 'Default',
                        'export.viewport': 'Current Viewport',
                        'export.pose-camera': '1st Camera Pose',
                        'export.fov': 'Field of View',
                        'export.background-color': 'Background',
                        'export.filename': 'Filename',
                        'export.animation': 'Animation',
                        'export.animation-none': 'None',
                        'export.animation-track': 'Track',
                        'export.ply-compress': 'Compress PLY',
                        'export.splats-select': 'Splats',
                        'export.splats-select.all': 'All Splats',
                        'export.format': 'File Format',
                        'export.format-compressed-ply': 'Compressed PLY',
                        'export.format-sogs': 'SOGS',

                        // Cursor
                        'cursor.click-to-copy': 'Click to copy',
                        'cursor.copied': 'Copied!',

                        // Doc
                        'doc.reset': 'RESET SCENE',
                        'doc.unsaved-message': 'You have unsaved changes. Are you sure you want to reset the scene?',
                        'doc.reset-message': 'Are you sure you want to reset the scene?',
                        'doc.save-failed': 'FAILED TO SAVE',
                        'doc.load-failed': 'FAILED TO LOAD',

                        // Publish Settings Dialog
                        'publish.header': 'PUBLISH SETTINGS',
                        'publish.ok': 'Publish',
                        'publish.cancel': 'Cancel',
                        'publish.title': 'Title',
                        'publish.description': 'Description',
                        'publish.listed': 'Listed',
                        'publish.failed': 'PUBLISH FAILED',
                        'publish.please-try-again': 'Please try again later.',
                        'publish.succeeded': 'PUBLISH SUCCEEDED',
                        'publish.message': 'Use the link below to access your scene.',
                        'publish.please-log-in': 'Publishing to PlayCanvas requires a user account. Please log in and try again.',
                        'publish.converting': 'Converting...',
                        'publish.uploading': 'Uploading...',

                        // Image Settings Dialog
                        'image.header': 'IMAGE SETTINGS',
                        'image.preset': 'Preset',
                        'image.resolution': 'Resolution',
                        'image.transparentBg': 'Transparent Background',
                        'image.showDebug': 'Show Debug Overlays',
                        'image.resolutionCurrent': 'Current',
                        'image.resolutionCustom': 'Custom',

                        // Video Settings Dialog
                        'video.header': 'VIDEO SETTINGS',
                        'video.resolution': 'Resolution',
                        'video.frameRate': 'Frame Rate',
                        'video.bitrate': 'Bitrate',
                        'video.portrait': 'Portrait Mode',
                        'video.transparentBg': 'Transparent Background',
                        'video.showDebug': 'Show Debug Overlays',

                        // Timeline
                        'timeline.prev-key': 'Jump to previous keyframe',
                        'timeline.play': 'Play/Stop',
                        'timeline.next-key': 'Jump to next keyframe',
                        'timeline.add-key': 'Add Key',
                        'timeline.remove-key': 'Remove Key',
                        'timeline.frame-rate': 'Frame Rate',
                        'timeline.total-frames': 'Total Frames',

                        // Image Viewer Panel
                        'image-viewer': 'Image Viewer',

                        // Image Import
                        'image.import': 'Import images',
                        'image-config.import': 'Import image configuration',
                        'file.import.blg': 'Import BLGS...',
                        // User
                        'user.login': 'Login',
                        'user.logout': 'Log out',
                        'user.scenes': 'Scenes',
                        'user.account': 'Account',
                        'user.email': 'Email/Username',
                        'user.password': 'Password',
                        'user.invalid-credentials': 'Invalid email or password.',
                        'user.login-failed': 'Login failed. Please try again.',
                        'user.scenes.header': 'REMOTE SCENES',
                        'user.scenes.upload': 'Upload New Scene',
                        'user.scenes.download': 'Download',
                        'user.upload.header': 'UPLOAD SCENE',
                        'user.upload.photos': 'Photos',
                        'user.upload.video': 'Video',
                        'user.upload.photos-desc': 'Select multiple photos for reconstruction.',
                        'user.upload.video-desc': 'Select a single video file for reconstruction.',
                        'user.upload.drop-files': 'Drop files here or click to select.',
                        'user.upload.pick-files': 'Pick Files',
                        'user.upload.project-name': 'Project Name',
                        'user.upload.error-no-files': 'Please select at least one file.',
                        'user.upload.error-no-name': 'Please enter a project name.',
                        'user.upload.error-mixed': 'You cannot upload photos and videos together.',
                        'user.upload.error-multiple-videos': 'Only one video can be uploaded at a time.',

                        // Evidence
                        'evidence.evidence': 'Evidence',
                        'evidence.focus': 'Focus',
                        'evidence.add-photo': '+ Photo',
                        'evidence.name': 'Name',
                        'evidence.name-box': 'Evidence name...',
                        'evidence.position': 'Position',
                        'evidence.use-camera-focus': '📍 Use Camera Focus',
                        'evidence.use-camera-focus-extend': 'Drag the gizmo in the 3D view to move',
                        'evidence.size': 'Size (half-extents)',
                        'evidence.photos': 'Photos',
                        'evidence.add-photo-button': '+ Add Photos',
                        'evidence.create-evidence': 'Create Evidence',
                        'evidence.cancel': 'Cancel',
                        'evidence.add-new-evidence': 'Add new evidence',
                        'evidence.images': 'images',
                        'evidence.new-evidence': '(new evidence)',
                        'evidence.remove': 'Remove',
                        'evidence.remove-evidence': 'Remove evidence',
                        'evidence.removal-approve': 'Remove \"{{label0}}\"? This cannot be undone.',
                        'evidence.no-evidence-found': 'No evidence found in this scene, click + to add new...'
                    }
                },
                fr: {
                    translation: {
                        // File menu
                        'file': 'Fichier',
                        'file.new': 'Créer',
                        'file.open': 'Ouvrir',
                        'file.import': 'Importer...',
                        'file.load-all-data': 'Charger toutes les données ply',
                        'file.save': 'Enregistrer',
                        'file.save-as': 'Enregistrer sous...',
                        'file.publish': 'Publier...',
                        'file.export': 'Exporter',
                        'file.export.splat': 'Fichier splat',
                        'file.export.viewer': 'Application de visualisation...',
                        'download.reference.pdf': 'Télécharger le PDF de référence',

                        // Render menu
                        'render': 'Rendu',
                        'render.image': 'Image...',
                        'render.video': 'Vidéo...',
                        'render.ok': 'Rendu',
                        'render.cancel': 'Annuler',

                        // Selection menu
                        'select': 'Sélection',
                        'select.all': 'Tout',
                        'select.none': 'Aucune',
                        'select.invert': 'Inverser',
                        'select.lock': 'Verrouiller la sélection',
                        'select.unlock': 'Tout débloquer',
                        'select.delete': 'Supprimer la sélection',
                        'select.reset': 'Réinitialiser splat',
                        'select.duplicate': 'Dupliquer',
                        'select.separate': 'Séparer',

                        // Help menu
                        'help': 'Aide',
                        'help.shortcuts': 'Raccourcis claviers',
                        'help.user-guide': 'Guide utilisateur',
                        'help.log-issue': 'Signaler un problème',
                        'help.github-repo': 'Dépôt GitHub',
                        'help.basics-video': 'Vidéo de base',
                        'help.discord': 'Serveur Discord',
                        'help.forum': 'Forum',
                        'help.about': 'À propos de Biligoba Scene Forensics',

                        // Modes
                        'mode.centers': 'Mode centres',
                        'mode.rings': 'Mode anneaux',

                        // Scene panel
                        'scene-manager': 'GESTIONNAIRE DE SCENE',
                        'transform': 'TRANSFORMATION',
                        'position': 'Position',
                        'rotation': 'Rotation',
                        'scale': 'Échelle',

                        // Options panel
                        'options': 'OPTIONS D\'AFFICHAGE',
                        'options.colors': 'Couleurs',
                        'options.bg-color': 'Couleur de fond',
                        'options.selected-color': 'Couleur sélectionnée',
                        'options.unselected-color': 'Couleur non sélectionnée',
                        'options.locked-color': 'Couleur verrouillée',
                        'options.fov': 'Champ de vision',
                        'options.sh-bands': 'Ordres d\'HS',
                        'options.centers-size': 'Échelle des centres',
                        'options.outline-selection': 'Contour de la sélection',
                        'options.show-grid': 'Afficher la grille',
                        'options.show-bound': 'Afficher limites',
                        'options.camera-fly-speed': 'Vitesse de vol',
                        'options.high-precision': 'Haute Qualité',

                        // Camera panel
                        'camera': 'POSES DE LA CAMERA',
                        'camera.add-pose': 'Ajouter une pose',
                        'camera.prev-pose': 'Pose précédente',
                        'camera.next-pose': 'Pose suivante',
                        'camera.play-poses': 'Lire les poses',
                        'camera.clear-poses': 'Effacer les poses',

                        // Color panel
                        'colors': 'COULEURS',
                        'colors.tint': 'Teinte',
                        'colors.temperature': 'Température',
                        'colors.saturation': 'Saturation',
                        'colors.brightness': 'Luminosité',
                        'colors.blackPoint': 'Point noir',
                        'colors.whitePoint': 'Point blanc',
                        'colors.transparency': 'Transparence',
                        'colors.reset': 'Réinitialiser',

                        // Data panel
                        'data': 'DONNEES SPLAT',
                        'data.distance': 'Distance',
                        'data.volume': 'Volume',
                        'data.surface-area': 'Zone de surface',
                        'data.scale-x': 'Échelle X',
                        'data.scale-y': 'Échelle Y',
                        'data.scale-z': 'Échelle Z',
                        'data.red': 'Rouge',
                        'data.green': 'Vert',
                        'data.blue': 'Bleu',
                        'data.opacity': 'Opacité',
                        'data.hue': 'Teinte',
                        'data.saturation': 'Saturation',
                        'data.value': 'Luminosité',
                        'data.log-scale': 'Échelle logarithmique',
                        'data.totals': 'Totaux',
                        'data.totals.splats': 'Splats',
                        'data.totals.selected': 'Selectionné',
                        'data.totals.locked': 'Verrouillé',
                        'data.totals.deleted': 'Supprimé',

                        // Shortcuts panel
                        'shortcuts.title': 'RACCOURCIS CLAVIERS',
                        'shortcuts.movement': 'MOUVEMENT',
                        'shortcuts.move-forward': 'Avancer',
                        'shortcuts.move-backward': 'Reculer',
                        'shortcuts.move-left': 'Déplacer à gauche',
                        'shortcuts.move-right': 'Déplacer à droite',
                        'shortcuts.move-up': 'Déplacer vers le haut',
                        'shortcuts.move-down': 'Déplacer vers le bas',
                        'shortcuts.move-fast': 'Déplacement rapide (10x)',
                        'shortcuts.move-slow': 'Déplacement lent (0.1x)',
                        'shortcuts.camera': 'CAMÉRA',
                        'shortcuts.zoom': 'Zoom',
                        'shortcuts.pan': 'Panoramer',
                        'shortcuts.zoom-fast': 'Zoom rapide',
                        'shortcuts.orbit': 'Orbiter la caméra',
                        'shortcuts.focus-point': 'Définir le point focal',
                        'shortcuts.other': 'AUTRES',
                        'shortcuts.toggle-camera-mode': 'Basculer le mode de camera',
                        'shortcuts.toggle-grid': 'Afficher/Cacher la grille',
                        'shortcuts.toggle-gizmo-coordinate-space': 'Basculer en espace de coordonnées Gizmo',

                        // Popup
                        'popup.ok': 'OK',
                        'popup.cancel': 'Annuler',
                        'popup.yes': 'Oui',
                        'popup.no': 'Non',
                        'popup.error': 'ERREUR',
                        'popup.error-loading': 'Erreur de chargement du fichier',
                        'popup.drop-files': 'Veuillez déposer des fichiers et des dossiers',
                        'popup.copy-to-clipboard': 'Copier le lien dans le presse-papiers',

                        // Right toolbar
                        'tooltip.splat-mode': 'Mode splat ( M )',
                        'tooltip.show-hide': 'Afficher/cacher les splats ( Barre espace )',
                        'tooltip.frame-selection': 'Cadrer la sélection ( F )',
                        'tooltip.camera-reset': 'Réinitialiser la caméra',
                        'tooltip.color-panel': 'Couleurs',
                        'tooltip.view-options': 'Options d\'affichage',
                        'tooltip.clickable-zones': 'Preuves',
                        'tooltip.evidence-list': 'Liste des preuves',
                        'tooltip.show-associated-picture': 'Afficher l\'image associée',

                        // Bottom toolbar
                        'tooltip.undo': 'Annuler ( Ctrl + Z )',
                        'tooltip.redo': 'Rétablir ( Ctrl + Shift + Z )',
                        'tooltip.picker': 'Sélection avec pipette ( R )',
                        'tooltip.polygon': 'Sélection avec polygone ( P )',
                        'tooltip.brush': 'Sélection avec pinceau ( B )',
                        'tooltip.sphere': 'Sélection avec sphère',
                        'tooltip.box': 'Sélection de boîte',
                        'tooltip.translate': 'Translation ( 1 )',
                        'tooltip.rotate': 'Rotation ( 2 )',
                        'tooltip.scale': 'Échelle ( 3 )',
                        'tooltip.local-space': 'Espace local gizmo',
                        'tooltip.bound-center': 'Utiliser le centre de la limite',
                        'tooltip.measure-distance': 'Mesurer la distance',

                        // Measure Tool
                        'measure.distance': 'Distance',

                        // Viewer Export
                        'export.header': 'EXPORTER',
                        'export.type': 'Type d\'export',
                        'export.html': 'HTML',
                        'export.package': 'Package ZIP',
                        'export.sh-bands': 'Bandes SH',
                        'export.start-position': 'Position de départ',
                        'export.default': 'Défaut',
                        'export.viewport': 'Vue actuelle',
                        'export.pose-camera': '1ère pose de caméra',
                        'export.fov': 'Champ de vision',
                        'export.background-color': 'Arrière-plan',
                        'export.filename': 'Nom de fichier',
                        'export.animation': 'Animation',
                        'export.animation-none': 'Aucune',
                        'export.animation-track': 'Piste',
                        'export.ply-compress': 'Compresser PLY',
                        'export.splats-select': 'Splats',
                        'export.splats-select.all': 'Tous les Splats',
                        'export.format': 'Format de fichier',
                        'export.format-compressed-ply': 'PLY compressé',
                        'export.format-sogs': 'SOGS',

                        // Cursor
                        'cursor.click-to-copy': 'Cliquez pour copier',
                        'cursor.copied': 'Copié!',

                        // Doc
                        'doc.reset': 'REINITIALISER LA SCENE',
                        'doc.unsaved-message': 'Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir réinitialiser la scène?',
                        'doc.reset-message': 'Êtes-vous sûr de vouloir réinitialiser la scène?',
                        'doc.save-failed': 'ÉCHEC DE L\'ENREGISTREMENT',
                        'doc.load-failed': 'ÉCHEC DU CHARGEMENT',

                        // Publish Settings Dialog
                        'publish.header': 'PARAMETRES DE PUBLICATION',
                        'publish.ok': 'Publier',
                        'publish.cancel': 'Annuler',
                        'publish.title': 'Titre',
                        'publish.description': 'Description',
                        'publish.listed': 'Répertorié',
                        'publish.failed': 'ÉCHEC DE PUBLICATION',
                        'publish.please-try-again': 'Veuillez réessayer plus tard.',
                        'publish.succeeded': 'PUBLICATION RÉUSSIE',
                        'publish.message': 'Utilisez le lien ci-dessous pour accéder à votre scène.',
                        'publish.please-log-in': 'La publication sur PlayCanvas nécessite un compte utilisateur. Veuillez vous connecter et réessayer.',

                        // Video Settings Dialog
                        'video.header': 'PARAMETRES VIDEO',
                        'video.resolution': 'Résolution',
                        'video.frameRate': 'Fréquence d\'image',
                        'video.bitrate': 'Débit binaire',
                        'video.portrait': 'Mode portrait',
                        'video.transparentBg': 'Fond transparent',
                        'video.showDebug': 'Afficher les superpositions de débogage',

                        // Timeline
                        'timeline.prev-key': 'Aller à la clé précédente',
                        'timeline.play': 'Jouer/Arrêter',
                        'timeline.next-key': 'Aller à la clé suivante',
                        'timeline.add-key': 'Ajouter une clé',
                        'timeline.remove-key': 'Supprimer une clé',
                        'timeline.frame-rate': 'Fréquence d\'image',
                        'timeline.total-frames': 'Nombre total de frames',

                        // Image Viewer Panel
                        'image-viewer': 'Visionneuse d’images',

                        // Image Import
                        'image.import': 'Importer des images',
                        'image-config.import': 'Importer la configuration d’image',
                        'file.import.blg': 'Importer BLGS...',
                        // User
                        'user.login': 'Connexion',
                        'user.logout': 'Déconnexion',
                        'user.scenes': 'Scènes',
                        'user.account': 'Compte',
                        'user.email': 'E-mail/Nom d\'utilisateur',
                        'user.password': 'Mot de passe',
                        'user.invalid-credentials': 'E-mail ou mot de passe invalide.',
                        'user.login-failed': 'Échec de la connexion. Veuillez réessayer.',
                        'user.scenes.header': 'SCÈNES DISTANTES',
                        'user.scenes.upload': 'Télécharger une nouvelle scène',
                        'user.scenes.download': 'Télécharger',
                        'user.upload.header': 'TÉLÉCHARGER LA SCÈNE',
                        'user.upload.photos': 'Photos',
                        'user.upload.video': 'Vidéo',
                        'user.upload.photos-desc': 'Sélectionnez plusieurs photos pour la reconstruction.',
                        'user.upload.video-desc': 'Sélectionnez un seul fichier vidéo pour la reconstruction.',
                        'user.upload.drop-files': 'Déposez les fichiers ici ou cliquez pour sélectionner',
                        'user.upload.pick-files': 'Choisir des fichiers',
                        'user.upload.project-name': 'Nom du projet',
                        'user.upload.error-no-files': 'Veuillez sélectionner au moins un fichier.',
                        'user.upload.error-no-name': 'Veuillez saisir un nom de projet.',
                        'user.upload.error-mixed': 'Vous ne pouvez pas télécharger des photos et des vidéos ensemble.',
                        'user.upload.error-multiple-videos': 'Une seule vidéo peut être téléchargée à la fois.'
                    }
                },
                ja: {
                    translation: {
                        // File menu
                        'file': 'ファイル',
                        'file.new': '新規作成',
                        'file.open': '開く',
                        'file.import': 'インポート...',
                        'file.load-all-data': '全てのPLYデータを読み込む',
                        'file.save': '保存',
                        'file.save-as': '名前を付けて保存',
                        'file.publish': '公開...',
                        'file.export': 'エクスポート',
                        'file.export.splat': 'Splat (.splat)',
                        'file.export.viewer': 'Viewer App...',
                        'download.reference.pdf': 'リファレンスPDFをダウンロード',

                        // Render menu
                        'render': 'レンダリング',
                        'render.image': '画像...',
                        'render.video': '動画...',
                        'render.ok': 'レンダリング',
                        'render.cancel': 'キャンセル',

                        // Selection menu
                        'select': '選択',
                        'select.all': '全て',
                        'select.none': '選択を解除',
                        'select.invert': '反転',
                        'select.lock': '選択をロック',
                        'select.unlock': 'ロックを解除',
                        'select.delete': '選択を削除',
                        'select.reset': '変更を全てリセット',
                        'select.duplicate': '複製',
                        'select.separate': '分離',

                        // Help menu
                        'help': 'ヘルプ',
                        'help.shortcuts': 'キーボードショートカット',
                        'help.user-guide': 'ユーザーガイド',
                        'help.log-issue': '問題を報告',
                        'help.github-repo': 'GitHubリポジトリ',
                        'help.basics-video': '基本ビデオ',
                        'help.discord': 'Discordサーバー',
                        'help.forum': 'フォーラム',
                        'help.about': 'Biligoba Scene Forensicsについて',

                        // Modes
                        'mode.centers': 'センターモード',
                        'mode.rings': 'リングモード',

                        // Scene panel
                        'scene-manager': 'シーンマネージャー',
                        'transform': 'トランスフォーム',
                        'position': '位置',
                        'rotation': '回転',
                        'scale': 'スケール',

                        // Options panel
                        'options': '表示オプション',
                        'options.colors': '色',
                        'options.bg-color': '背景色',
                        'options.selected-color': '選択色',
                        'options.unselected-color': '非選択色',
                        'options.locked-color': 'ロック色',
                        'options.fov': '視野 ( FOV )',
                        'options.sh-bands': '球面調和関数のバンド',
                        'options.centers-size': 'センターサイズ',
                        'options.outline-selection': '選択のアウトライン',
                        'options.show-grid': 'グリッド',
                        'options.show-bound': 'バウンディングボックス',
                        'options.camera-fly-speed': 'カメラ速度',
                        'options.high-precision': '高品質',

                        // Camera panel
                        'camera': 'カメラポーズ',
                        'camera.add-pose': 'ポーズを追加',
                        'camera.prev-pose': '前のポーズ',
                        'camera.next-pose': '次のポーズ',
                        'camera.play-poses': 'ポーズを再生',
                        'camera.clear-poses': 'ポーズをクリア',

                        // Color panel
                        'colors': '色',
                        'colors.tint': '色合い',
                        'colors.temperature': '温度',
                        'colors.saturation': '彩度',
                        'colors.brightness': '明るさ',
                        'colors.blackPoint': '黒点',
                        'colors.whitePoint': '白点',
                        'colors.transparency': '透明度',
                        'colors.reset': 'リセット',

                        // Data panel
                        'data': 'スプラットの統計',
                        'data.distance': '距離',
                        'data.volume': '体積',
                        'data.surface-area': '表面積',
                        'data.scale-x': 'スケール X',
                        'data.scale-y': 'スケール Y',
                        'data.scale-z': 'スケール Z',
                        'data.red': '赤',
                        'data.green': '緑',
                        'data.blue': '青',
                        'data.opacity': '不透明度',
                        'data.hue': '色相',
                        'data.saturation': '彩度',
                        'data.value': '明度',
                        'data.log-scale': '対数スケール',
                        'data.totals': '合計',
                        'data.totals.splats': 'スプラット数',
                        'data.totals.selected': '選択中',
                        'data.totals.locked': 'ロック中',
                        'data.totals.deleted': '削除',

                        // Shortcuts panel
                        'shortcuts.title': 'キーボードショートカット',
                        'shortcuts.movement': '移動',
                        'shortcuts.move-forward': '前進',
                        'shortcuts.move-backward': '後退',
                        'shortcuts.move-left': '左移動',
                        'shortcuts.move-right': '右移動',
                        'shortcuts.move-up': '上昇',
                        'shortcuts.move-down': '下降',
                        'shortcuts.move-fast': '高速移動 (10x)',
                        'shortcuts.move-slow': '低速移動 (0.1x)',
                        'shortcuts.camera': 'カメラ',
                        'shortcuts.zoom': 'ズーム',
                        'shortcuts.pan': 'パン',
                        'shortcuts.zoom-fast': '高速ズーム',
                        'shortcuts.orbit': 'カメラ回転',
                        'shortcuts.focus-point': '焦点設定',
                        'shortcuts.other': 'その他',
                        'shortcuts.toggle-camera-mode': 'カメラモードの切り替え',
                        'shortcuts.toggle-grid': 'グリッドの切り替え',
                        'shortcuts.toggle-gizmo-coordinate-space': 'ギズモ座標空間の切り替え',

                        // Popup
                        'popup.ok': 'OK',
                        'popup.cancel': 'キャンセル',
                        'popup.yes': 'はい',
                        'popup.no': 'いいえ',
                        'popup.error': 'エラー',
                        'popup.error-loading': 'ファイルの読み込みエラー',
                        'popup.drop-files': 'ファイルやフォルダをドロップしてください',
                        'popup.copy-to-clipboard': 'リンクをクリップボードにコピー',

                        // Right toolbar
                        'tooltip.splat-mode': 'スプラットモード ( M )',
                        'tooltip.show-hide': 'スプラットの表示/非表示 ( Space )',
                        'tooltip.frame-selection': '選択をフレームイン ( F )',
                        'tooltip.camera-reset': 'カメラをリセット',
                        'tooltip.color-panel': '色',
                        'tooltip.view-options': '表示オプション',
                        'tooltip.clickable-zones': '証拠',
                        'tooltip.evidence-list': '証拠リスト',
                        'tooltip.show-associated-picture': '関連画像を表示',

                        // Bottom toolbar
                        'tooltip.undo': '元に戻す ( Ctrl + Z )',
                        'tooltip.redo': 'やり直し ( Ctrl + Shift + Z )',
                        'tooltip.picker': 'ピッカー選択 ( R )',
                        'tooltip.polygon': 'ポリゴン選択 ( P )',
                        'tooltip.brush': 'ブラシ選択 ( B )',
                        'tooltip.sphere': '球で選択',
                        'tooltip.box': '箱で選択',
                        'tooltip.translate': '移動 ( 1 )',
                        'tooltip.rotate': '回転 ( 2 )',
                        'tooltip.scale': 'スケール ( 3 )',
                        'tooltip.local-space': 'ローカル座標へ切り替え',
                        'tooltip.bound-center': 'バウンディングボックスの中心を使用',
                        'tooltip.measure-distance': '距離を測定',

                        // Measure Tool
                        'measure.distance': '距離',

                        // Viewer Export
                        'export.header': 'エクスポート',
                        'export.type': 'エクスポートタイプ',
                        'export.html': 'HTML',
                        'export.package': 'ZIPパッケージ',
                        'export.sh-bands': 'SHバンド',
                        'export.start-position': '開始位置',
                        'export.default': 'デフォルト',
                        'export.viewport': '現在のビューポート',
                        'export.pose-camera': '1番目のカメラポーズ',
                        'export.fov': '視野角',
                        'export.background-color': '背景色',
                        'export.filename': 'ファイル名',
                        'export.animation': 'アニメーション',
                        'export.animation-none': 'なし',
                        'export.animation-track': 'トラック',
                        'export.ply-compress': 'PLYを圧縮',
                        'export.splats-select': 'Splat',
                        'export.splats-select.all': 'すべてのSplat',
                        'export.format': 'ファイル形式',
                        'export.format-compressed-ply': '圧縮PLY',
                        'export.format-sogs': 'SOGS',

                        // Cursor
                        'cursor.click-to-copy': 'クリックしてコピー',
                        'cursor.copied': 'コピーしました！',

                        // Doc
                        'doc.reset': 'シーンをリセット',
                        'doc.unsaved-message': '保存されていない変更があります。シーンをリセットしてもよろしいですか？',
                        'doc.reset-message': 'シーンをリセットしてもよろしいですか？',
                        'doc.save-failed': '保存に失敗',
                        'doc.load-failed': '読み込みに失敗',

                        // Publish Settings Dialog
                        'publish.header': '公開設定',
                        'publish.ok': '公開',
                        'publish.cancel': 'キャンセル',
                        'publish.title': 'タイトル',
                        'publish.description': '説明',
                        'publish.listed': 'リスト',
                        'publish.failed': '公開に失敗',
                        'publish.please-try-again': '後でもう一度お試しください。',
                        'publish.succeeded': '公開に成功',
                        'publish.message': '以下のリンクを使用してシーンにアクセスしてください。',
                        'publish.please-log-in': 'PlayCanvasに公開するにはユーザーアカウントが必要です。ログインしてもう一度お試しください。',

                        // Video Settings Dialog
                        'video.header': 'ビデオ設定',
                        'video.resolution': '解像度',
                        'video.frameRate': 'フレームレート',
                        'video.bitrate': 'ビットレート',
                        'video.portrait': 'ポートレートモード',
                        'video.transparentBg': '透明な背景',
                        'video.showDebug': 'デバッグオーバーレイを表示',

                        // Timeline
                        'timeline.prev-key': '前のキーフレームに移動',
                        'timeline.play': '再生/停止',
                        'timeline.next-key': '次のキーフレームに移動',
                        'timeline.add-key': 'キーフレームを追加',
                        'timeline.remove-key': 'キーフレームを削除',
                        'timeline.frame-rate': 'フレームレート',
                        'timeline.total-frames': '総フレーム数',

                        // Image Viewer Panel
                        'image-viewer': '画像ビューア',

                        // Image Import
                        'image.import': '画像をインポート',
                        'image-config.import': '画像設定をインポート',
                        // User
                        'user.login': 'ログイン',
                        'user.logout': 'ログアウト',
                        'user.scenes': '現場',
                        'user.account': 'アカウント',
                        'user.email': 'メール/ユーザー名',
                        'user.password': 'パスワード',
                        'user.invalid-credentials': 'メールアドレスまたはパスワードが無効です。',
                        'user.login-failed': 'ログインに失敗しました。もう一度お試しください。',
                        'user.scenes.header': 'リモートシーン',
                        'user.scenes.upload': '新しいシーンをアップロード',
                        'user.scenes.download': 'ダウンロード',
                        'user.upload.header': 'シーンのアップロード',
                        'user.upload.photos': '写真',
                        'user.upload.video': 'ビデオ',
                        'user.upload.photos-desc': '再構築のために複数の写真を選択してください。',
                        'user.upload.video-desc': '再構築のために単一のビデオファイルを選択してください。',
                        'user.upload.drop-files': 'ここにファイルをドロップするか、クリックして選択',
                        'user.upload.pick-files': 'ファイルを選択',
                        'user.upload.project-name': 'プロジェクト名',
                        'user.upload.error-no-files': '少なくとも1つのファイルを選択してください。',
                        'user.upload.error-no-name': 'プロジェクト名を入力してください。',
                        'user.upload.error-mixed': '写真とビデオを一緒にアップロードすることはできません。',
                        'user.upload.error-multiple-videos': '一度にアップロードできるビデオは1つだけです。'
                    }
                },
                ko: {
                    translation: {
                        // File menu
                        'file': '파일',
                        'file.new': '새로 만들기',
                        'file.open': '열기',
                        'file.import': '가져오기...',
                        'file.load-all-data': '모든 PLY 데이터 불러오기',
                        'file.save': '저장',
                        'file.save-as': '다른 이름으로 저장...',
                        'file.publish': '게시...',
                        'file.export': '내보내기',
                        'file.export.splat': 'Splat 파일',
                        'file.export.viewer': '뷰어 앱...',
                        'download.reference.pdf': '참조 PDF 다운로드',

                        // Render menu
                        'render': '렌더링',
                        'render.image': '이미지...',
                        'render.video': '비디오...',
                        'render.ok': '렌더링',
                        'render.cancel': '취소',

                        // Selection menu
                        'select': '선택',
                        'select.all': '모두',
                        'select.none': '없음',
                        'select.invert': '반전',
                        'select.lock': '선택 잠금',
                        'select.unlock': '모두 잠금 해제',
                        'select.delete': '선택 삭제',
                        'select.reset': 'Splat 재설정',
                        'select.duplicate': '복제',
                        'select.separate': '분리',

                        // Help menu
                        'help': '도움말',
                        'help.shortcuts': '키보드 단축키',
                        'help.user-guide': '사용자 가이드',
                        'help.log-issue': '문제 보고',
                        'help.github-repo': 'GitHub 저장소',
                        'help.basics-video': '기본 비디오',
                        'help.discord': 'Discord 서버',
                        'help.forum': '포럼',
                        'help.about': 'Biligoba Scene Forensics 정보',

                        // Modes
                        'mode.centers': '센터 모드',
                        'mode.rings': '링 모드',

                        // Scene panel
                        'scene-manager': '장면 관리자',
                        'transform': '변환',
                        'position': '위치',
                        'rotation': '회전',
                        'scale': '크기',

                        // Options panel
                        'options': '보기 옵션',
                        'options.colors': '색상',
                        'options.bg-color': '배경 색상',
                        'options.selected-color': '선택된 색상',
                        'options.unselected-color': '선택되지 않은 색상',
                        'options.locked-color': '잠긴 색상',
                        'options.fov': '시야각',
                        'options.sh-bands': 'SH 밴드',
                        'options.centers-size': '센터 크기',
                        'options.outline-selection': '선택 윤곽선',
                        'options.show-grid': '그리드 표시',
                        'options.show-bound': '경계 표시',
                        'options.camera-fly-speed': '카메라 속도',
                        'options.high-precision': '고품질',

                        // Camera panel
                        'camera': '카메라 포즈',
                        'camera.add-pose': '포즈 추가',
                        'camera.prev-pose': '이전 포즈',
                        'camera.next-pose': '다음 포즈',
                        'camera.play-poses': '포즈 재생',
                        'camera.clear-poses': '포즈 지우기',

                        // Color panel
                        'colors': '색상',
                        'colors.tint': '색조',
                        'colors.temperature': '온도',
                        'colors.brightness': '밝기',
                        'colors.blackPoint': '검은 점',
                        'colors.whitePoint': '흰 점',
                        'colors.transparency': '투명도',
                        'colors.reset': '리셋',

                        // Data panel
                        'data': 'SPLAT 데이터',
                        'data.distance': '거리',
                        'data.volume': '부피',
                        'data.surface-area': '표면적',
                        'data.scale-x': '크기 X',
                        'data.scale-y': '크기 Y',
                        'data.scale-z': '크기 Z',
                        'data.red': '빨강',
                        'data.green': '녹색',
                        'data.blue': '파랑',
                        'data.opacity': '불투명도',
                        'data.hue': '색조',
                        'data.saturation': '채도',
                        'data.value': '명도',
                        'data.log-scale': '로그 크기',
                        'data.totals': '합계',
                        'data.totals.splats': 'Splat',
                        'data.totals.selected': '선택',
                        'data.totals.locked': '잠금',
                        'data.totals.deleted': '삭제된',

                        // Shortcuts panel
                        'shortcuts.title': '키보드 단축키',
                        'shortcuts.movement': '이동',
                        'shortcuts.move-forward': '전진',
                        'shortcuts.move-backward': '후진',
                        'shortcuts.move-left': '왼쪽 이동',
                        'shortcuts.move-right': '오른쪽 이동',
                        'shortcuts.move-up': '위로 이동',
                        'shortcuts.move-down': '아래로 이동',
                        'shortcuts.move-fast': '빠른 이동 (10x)',
                        'shortcuts.move-slow': '느린 이동 (0.1x)',
                        'shortcuts.camera': '카메라',
                        'shortcuts.zoom': '줌',
                        'shortcuts.pan': '이동',
                        'shortcuts.zoom-fast': '빠른 줌',
                        'shortcuts.orbit': '카메라 회전',
                        'shortcuts.focus-point': '포커스 포인트 설정',
                        'shortcuts.tools': '도구',
                        'shortcuts.move': '이동',
                        'shortcuts.rotate': '회전',
                        'shortcuts.scale': '크기 조정',
                        'shortcuts.rect-selection': '사각형 선택',
                        'shortcuts.brush-selection': '브러시 선택',
                        'shortcuts.picker-selection': '피커 선택',
                        'shortcuts.brush-size': '브러시 크기 조정',
                        'shortcuts.deactivate-tool': '도구 비활성화',
                        'shortcuts.selection': '선택',
                        'shortcuts.select-all': '모두 선택',
                        'shortcuts.deselect-all': '모두 선택 해제',
                        'shortcuts.invert-selection': '선택 반전',
                        'shortcuts.add-to-selection': '선택 추가',
                        'shortcuts.remove-from-selection': '선택 제거',
                        'shortcuts.delete-selected-splats': '선택된 Splat 삭제',
                        'shortcuts.show': '표시',
                        'shortcuts.hide-selected-splats': '선택된 Splat 숨기기',
                        'shortcuts.unhide-all-splats': '모든 Splat 표시',
                        'shortcuts.toggle-data-panel': '데이터 패널 전환',
                        'shortcuts.other': '기타',
                        'shortcuts.select-next-splat': '다음 Splat 선택',
                        'shortcuts.undo': '실행 취소',
                        'shortcuts.redo': '다시 실행',
                        'shortcuts.toggle-splat-overlay': 'Splat 오버레이 전환',
                        'shortcuts.focus-camera': '현재 선택에 초점 맞추기',
                        'shortcuts.toggle-camera-mode': '카메라 모드 전환',
                        'shortcuts.toggle-grid': '그리드 전환',
                        'shortcuts.toggle-gizmo-coordinate-space': '기즈모 좌표 공간 전환',

                        // Popup
                        'popup.ok': '확인',
                        'popup.cancel': '취소',
                        'popup.yes': '예',
                        'popup.no': '아니요',
                        'popup.error': '오류',
                        'popup.error-loading': '파일 로드 오류',
                        'popup.drop-files': '파일 및 폴더를 드롭하세요',
                        'popup.copy-to-clipboard': '클립 보드에 링크 복사',

                        // Right toolbar
                        'tooltip.splat-mode': 'Splat 모드 ( M )',
                        'tooltip.show-hide': '스플래츠 표시/숨기기 ( Space )',
                        'tooltip.frame-selection': '프레임 선택 ( F )',
                        'tooltip.camera-reset': '카메라 재설정',
                        'tooltip.color-panel': '색상',
                        'tooltip.view-options': '보기 옵션',
                        'tooltip.clickable-zones': '증거',
                        'tooltip.evidence-list': '증거 목록',
                        'tooltip.show-associated-picture': '관련 사진 보기',

                        // Bottom toolbar
                        'tooltip.undo': '실행 취소 ( Ctrl + Z )',
                        'tooltip.redo': '다시 실행 ( Ctrl + Shift + Z )',
                        'tooltip.picker': '피커 선택 ( R )',
                        'tooltip.polygon': '다각형 선택 ( P )',
                        'tooltip.brush': '브러시 선택 ( B )',
                        'tooltip.sphere': '구 선택',
                        'tooltip.box': '상자 선택',
                        'tooltip.translate': '이동 ( 1 )',
                        'tooltip.rotate': '회전 ( 2 )',
                        'tooltip.scale': '크기 조정 ( 3 )',
                        'tooltip.local-space': '로컬 공간',
                        'tooltip.bound-center': '바운드 중심 사용',
                        'tooltip.measure-distance': '거리 측정',

                        // Measure Tool
                        'measure.distance': '거리',

                        // Viewer Export
                        'export.header': '내보내기',
                        'export.type': '내보내기 유형',
                        'export.html': 'HTML',
                        'export.package': 'ZIP 패키지',
                        'export.sh-bands': 'SH 밴드',
                        'export.start-position': '시작 위치',
                        'export.default': '기본값',
                        'export.viewport': '현재 뷰포트',
                        'export.pose-camera': '1번째 카메라 포즈',
                        'export.fov': '시야각',
                        'export.background-color': '배경색',
                        'export.filename': '파일 이름',
                        'export.animation': '애니메이션',
                        'export.animation-none': '없음',
                        'export.animation-track': '트랙',
                        'export.ply-compress': 'PLY 압축',
                        'export.splats-select': 'Splat',
                        'export.splats-select.all': '모든 Splat',
                        'export.format': '파일 형식',
                        'export.format-compressed-ply': '압축된 PLY',
                        'export.format-sogs': 'SOGS',

                        // Cursor
                        'cursor.click-to-copy': '클릭하여 복사',
                        'cursor.copied': '복사됨!',

                        // Doc
                        'doc.reset': '장면 재설정',
                        'doc.unsaved-message': '저장되지 않은 변경 사항이 있습니다. 장면을 재설정하시겠습니까?',
                        'doc.reset-message': '장면을 재설정하시겠습니까?',
                        'doc.save-failed': '저장 실패',
                        'doc.load-failed': '로드 실패',

                        // Publish Settings Dialog
                        'publish.header': '게시 설정',
                        'publish.ok': '게시',
                        'publish.cancel': '취소',
                        'publish.title': '제목',
                        'publish.description': '설명',
                        'publish.listed': '목록',
                        'publish.failed': '게시 실패',
                        'publish.please-try-again': '잠시 후 다시 시도하십시오.',
                        'publish.succeeded': '게시 성공',
                        'publish.message': '아래 링크를 사용하여 장면에 액세스하십시오.',
                        'publish.please-log-in': 'PlayCanvas에 게시하려면 사용자 계정이 필요합니다. 로그인하고 다시 시도하십시오.',

                        // Video Settings Dialog
                        'video.header': '비디오 설정',
                        'video.resolution': '해상도',
                        'video.frameRate': '프레임 속도',
                        'video.bitrate': '비트 전송률',
                        'video.portrait': '세로 모드',
                        'video.transparentBg': '투명 배경',
                        'video.showDebug': '디버그 오버레이 표시',

                        // Timeline
                        'timeline.prev-key': '이전 키로 이동',
                        'timeline.play': '재생/정지',
                        'timeline.next-key': '다음 키로 이동',
                        'timeline.add-key': '키 추가',
                        'timeline.remove-key': '키 제거',
                        'timeline.frame-rate': '프레임 속도',
                        'timeline.total-frames': '총 프레임 수',

                        // Image Viewer Panel
                        'image-viewer': '이미지 뷰어',

                        // Image Import
                        'image.import': '이미지 가져오기',
                        'image-config.import': '이미지 설정 가져오기',
                        // User
                        'user.login': '로그인',
                        'user.logout': '로그아웃',
                        'user.scenes': '현장',
                        'user.account': '계정',
                        'user.email': '이메일/사용자 이름',
                        'user.password': '비밀번호',
                        'user.invalid-credentials': '이메일 또는 비밀번호가 잘못되었습니다.',
                        'user.login-failed': '로그인에 실패했습니다. 다시 시도하십시오.',
                        'user.scenes.header': '원격 장면',
                        'user.scenes.upload': '새 장면 업로드',
                        'user.scenes.download': '다운로드',
                        'user.upload.header': '장면 업로드',
                        'user.upload.photos': '사진',
                        'user.upload.video': '비디오',
                        'user.upload.photos-desc': '재구성을 위해 여러 사진을 선택하십시오.',
                        'user.upload.video-desc': '재구성을 위해 단일 비디오 파일을 선택하십시오.',
                        'user.upload.drop-files': '여기에 파일을 드롭하거나 클릭하여 선택',
                        'user.upload.pick-files': '파일 선택',
                        'user.upload.project-name': '프로젝트 이름',
                        'user.upload.error-no-files': '최소한 하나의 파일을 선택하십시오.',
                        'user.upload.error-no-name': '프로젝트 이름을 입력하십시오.',
                        'user.upload.error-mixed': '사진과 비디오를 함께 업로드할 수 없습니다.',
                        'user.upload.error-multiple-videos': '한 번에 하나의 비디오만 업로드할 수 있습니다.'
                    }
                },
                tr: {
                    translation: {
                        // File menu
                        'file': 'Dosya',
                        'file.new': 'Yeni',
                        'file.open': 'Aç',
                        'file.import': 'İçe Aktar...',
                        'file.load-all-data': 'Tüm PLY verisini yükle',
                        'file.save': 'Kaydet',
                        'file.save-as': 'Farklı Kaydet...',
                        'file.publish': 'Yayınla...',
                        'file.export': 'Dışa Aktar',
                        'file.export.ply': 'PLY (.ply)',
                        'file.export.splat': 'Splat dosyası (.splat)',
                        'file.export.viewer': 'Görüntüleyici Uygulaması...',
                        'download.reference.pdf': 'Referans PDF\'i İndir',

                        // Render menu
                        'render': 'Render',
                        'render.image': 'Görsel...',
                        'render.video': 'Video...',
                        'render.ok': 'Render Al',
                        'render.cancel': 'İptal',
                        'render.render-video': 'Videoyu Render Al',
                        'render.rendering': 'Kareler render alınıyor...',

                        // Selection menu
                        'select': 'Seçim',
                        'select.all': 'Tümü',
                        'select.none': 'Hiçbiri',
                        'select.invert': 'Tersine Çevir',
                        'select.lock': 'Seçimi Kilitle',
                        'select.unlock': 'Tüm Kilitleri Aç',
                        'select.delete': 'Seçimi Sil',
                        'select.reset': "Splat'ı Sıfırla",
                        'select.duplicate': 'Çoğalt',
                        'select.separate': 'Ayır',

                        // Help menu
                        'help': 'Yardım',
                        'help.shortcuts': 'Klavye Kısayolları',
                        'help.user-guide': 'Kullanıcı Kılavuzu',
                        'help.log-issue': 'Sorun Bildir',
                        'help.github-repo': 'GitHub Deposu',
                        'help.basics-video': 'Temel Bilgiler Videosu',
                        'help.discord': 'Discord Sunucusu',
                        'help.forum': 'Forum',
                        'help.about': 'Biligoba Scene Forensics Hakkında',

                        // Modes
                        'mode.centers': 'Merkezler Modu',
                        'mode.rings': 'Halkalar Modu',

                        // Scene panel
                        'scene-manager': 'SAHNE YÖNETİCİSİ',
                        'transform': 'DÖNÜŞÜM',
                        'position': 'Konum',
                        'rotation': 'Döndürme',
                        'scale': 'Ölçek',

                        // Options panel
                        'options': 'GÖRÜNÜM SEÇENEKLERİ',
                        'options.colors': 'Renkler',
                        'options.bg-color': 'Arka Plan Rengi',
                        'options.selected-color': 'Seçili Renk',
                        'options.unselected-color': 'Seçili Olmayan Renk',
                        'options.locked-color': 'Kilitli Renk',
                        'options.fov': 'Görüş Alanı',
                        'options.sh-bands': 'SH Bantları',
                        'options.centers-size': 'Merkez Boyutu',
                        'options.outline-selection': 'Seçimin ana hatlarını göster',
                        'options.show-grid': 'Izgarayı Göster',
                        'options.show-bound': 'Sınır Kutusunu Göster',
                        'options.camera-fly-speed': 'Uçuş Hızı',
                        'options.tonemapping': 'Ton Eşleme',
                        'options.tonemapping-none': 'Yok',
                        'options.tonemapping-linear': 'Doğrusal',
                        'options.tonemapping-neutral': 'Nötr',
                        'options.tonemapping-aces': 'ACES',
                        'options.tonemapping-aces2': 'ACES2',
                        'options.tonemapping-filmic': 'Sinematik',
                        'options.tonemapping-hejl': 'Hejl',
                        'options.high-precision': 'Yüksek Kalite',

                        // Camera panel
                        'camera': 'KAMERA POZLARI',
                        'camera.add-pose': 'Poz Ekle',
                        'camera.prev-pose': 'Önceki Poz',
                        'camera.next-pose': 'Sonraki Poz',
                        'camera.play-poses': 'Pozları Oynat',
                        'camera.clear-poses': 'Pozları Temizle',

                        // Color panel
                        'colors': 'RENKLER',
                        'colors.tint': 'Ton',
                        'colors.temperature': 'Renk Sıcaklığı',
                        'colors.saturation': 'Doygunluk',
                        'colors.brightness': 'Parlaklık',
                        'colors.blackPoint': 'Siyah Noktası',
                        'colors.whitePoint': 'Beyaz Noktası',
                        'colors.transparency': 'Saydamlık',
                        'colors.reset': 'Sıfırla',

                        // Data panel
                        'data': 'SPLAT VERİLERİ',
                        'data.distance': 'Mesafe',
                        'data.volume': 'Hacim',
                        'data.surface-area': 'Yüzey Alanı',
                        'data.scale-x': 'Ölçek X',
                        'data.scale-y': 'Ölçek Y',
                        'data.scale-z': 'Ölçek Z',
                        'data.red': 'Kırmızı',
                        'data.green': 'Yeşil',
                        'data.blue': 'Mavi',
                        'data.opacity': 'Opaklık',
                        'data.hue': 'Renk Tonu',
                        'data.saturation': 'Doygunluk',
                        'data.value': 'Değer',
                        'data.log-scale': 'Logaritmik Ölçek',
                        'data.totals': 'Toplamlar',
                        'data.totals.splats': 'Splat',
                        'data.totals.selected': 'Seçili',
                        'data.totals.locked': 'Kilitli',
                        'data.totals.deleted': 'Silinen',

                        // Shortcuts panel
                        'shortcuts.title': 'KLAVYE KISAYOLLARI',
                        'shortcuts.movement': 'HAREKET',
                        'shortcuts.move-forward': 'İleri Git',
                        'shortcuts.move-backward': 'Geri Git',
                        'shortcuts.move-left': 'Sola Git',
                        'shortcuts.move-right': 'Sağa Git',
                        'shortcuts.move-up': 'Yukarı Git',
                        'shortcuts.move-down': 'Aşağı Git',
                        'shortcuts.move-fast': 'Hızlı Hareket (10x)',
                        'shortcuts.move-slow': 'Yavaş Hareket (0.1x)',
                        'shortcuts.camera': 'KAMERA',
                        'shortcuts.zoom': 'Yakınlaştır',
                        'shortcuts.pan': 'Kaydır',
                        'shortcuts.zoom-fast': 'Hızlı Yakınlaştır',
                        'shortcuts.orbit': 'Kamera Döndür',
                        'shortcuts.focus-point': 'Odak Noktası Ayarla',
                        'shortcuts.tools': 'ARAÇLAR',
                        'shortcuts.move': 'Taşı',
                        'shortcuts.rotate': 'Döndür',
                        'shortcuts.scale': 'Ölçekle',
                        'shortcuts.rect-selection': 'Dikdörtgen Seçim',
                        'shortcuts.brush-selection': 'Fırça Seçimi',
                        'shortcuts.picker-selection': 'Seçici ile Seçim',
                        'shortcuts.brush-size': 'Fırça boyutunu azalt/artır',
                        'shortcuts.deactivate-tool': 'Aracı Kapat',
                        'shortcuts.selection': 'SEÇİM',
                        'shortcuts.select-all': 'Tümünü Seç',
                        'shortcuts.deselect-all': 'Seçimi Kaldır',
                        'shortcuts.invert-selection': 'Seçimi Tersine Çevir',
                        'shortcuts.add-to-selection': 'Seçime Ekle',
                        'shortcuts.remove-from-selection': 'Seçimden Çıkar',
                        'shortcuts.delete-selected-splats': 'Seçili Splatları Sil',
                        'shortcuts.show': 'GÖRÜNÜRLÜK',
                        'shortcuts.hide-selected-splats': 'Seçili Splatları Gizle',
                        'shortcuts.unhide-all-splats': 'Tüm Splatları Göster',
                        'shortcuts.toggle-data-panel': 'Veri Panelini Aç/Kapat',
                        'shortcuts.other': 'DİĞER',
                        'shortcuts.select-next-splat': 'Sonraki Splatı Seç',
                        'shortcuts.undo': 'Geri Al',
                        'shortcuts.redo': 'Yinele',
                        'shortcuts.toggle-splat-overlay': 'Splat bindirmesini Aç/Kapat',
                        'shortcuts.focus-camera': 'Kamerayı geçerli seçime odakla',
                        'shortcuts.toggle-camera-mode': 'Kamera Modunu Değiştir',
                        'shortcuts.toggle-grid': 'Izgarayı Aç/Kapat',
                        'shortcuts.toggle-gizmo-coordinate-space': 'Gizmonun koordinat uzayını değiştir',

                        // Popup
                        'popup.ok': 'Tamam',
                        'popup.cancel': 'İptal',
                        'popup.yes': 'Evet',
                        'popup.no': 'Hayır',
                        'popup.error': 'HATA',
                        'popup.error-loading': 'DOSYA YÜKLENİRKEN HATA',
                        'popup.drop-files': 'Lütfen dosya ve klasörleri bırakın',
                        'popup.copy-to-clipboard': 'Bağlantıyı panoya kopyala',

                        // Right toolbar
                        'tooltip.splat-mode': 'Splat Modu ( M )',
                        'tooltip.show-hide': 'Splatları Göster/Gizle ( Boşluk )',
                        'tooltip.frame-selection': 'Seçimi Kadraja Al ( F )',
                        'tooltip.camera-reset': 'Kamerayı Sıfırla',
                        'tooltip.color-panel': 'Renkler',
                        'tooltip.view-options': 'Görünüm Seçenekleri',
                        'tooltip.clickable-zones': 'Deliller',
                        'tooltip.evidence-list': 'Delil Listesi',
                        'tooltip.show-associated-picture': 'İlişkili Görseli Göster',

                        // Bottom toolbar
                        'tooltip.undo': 'Geri Al ( Ctrl + Z )',
                        'tooltip.redo': 'Yinele ( Ctrl + Shift + Z )',
                        'tooltip.picker': 'Seçici ile Seç ( R )',
                        'tooltip.polygon': 'Poligon Seç ( P )',
                        'tooltip.brush': 'Fırça ile Seç ( B )',
                        'tooltip.sphere': 'Küre ile Seç',
                        'tooltip.box': 'Kutu ile Seç',
                        'tooltip.translate': 'Taşı ( 1 )',
                        'tooltip.rotate': 'Döndür ( 2 )',
                        'tooltip.scale': 'Ölçekle ( 3 )',
                        'tooltip.local-space': 'Yerel Yönelimi Kullan',
                        'tooltip.bound-center': 'Sınır Merkezini Kullan',
                        'tooltip.measure-distance': 'Mesafe Ölç ( M )',

                        // Measure tool
                        'measure.distance': 'Mesafe (m):',

                        // Viewer Export
                        'export.header': 'DIŞA AKTAR',
                        'export.type': 'Dışa Aktarım Türü',
                        'export.html': 'HTML',
                        'export.package': 'ZIP Paketi',
                        'export.sh-bands': 'SH Bantları',
                        'export.start-position': 'Başlangıç Konumu',
                        'export.default': 'Varsayılan',
                        'export.viewport': 'Geçerli Görünüm',
                        'export.pose-camera': '1. Kamera Pozu',
                        'export.fov': 'Görüş Alanı',
                        'export.background-color': 'Arka Plan',
                        'export.filename': 'Dosya Adı',
                        'export.animation': 'Animasyon',
                        'export.animation-none': 'Yok',
                        'export.animation-track': 'İz',
                        'export.ply-compress': 'PLY sıkıştır',
                        'export.splats-select': 'Splatlar',
                        'export.splats-select.all': 'Tüm Splatlar',
                        'export.format': 'Dosya Biçimi',
                        'export.format-compressed-ply': 'Sıkıştırılmış PLY',
                        'export.format-sogs': 'SOGS',

                        // Cursor
                        'cursor.click-to-copy': 'Kopyalamak için tıklayın',
                        'cursor.copied': 'Kopyalandı!',

                        // Doc
                        'doc.reset': 'SAHNEYİ SIFIRLA',
                        'doc.unsaved-message': 'Kaydedilmemiş değişiklikleriniz var. Sahneyi sıfırlamak istediğinize emin misiniz?',
                        'doc.reset-message': 'Sahneyi sıfırlamak istediğinize emin misiniz?',
                        'doc.save-failed': 'KAYDETME BAŞARISIZ',
                        'doc.load-failed': 'YÜKLEME BAŞARISIZ',

                        // Publish Settings Dialog
                        'publish.header': 'YAYINLAMA AYARLARI',
                        'publish.ok': 'Yayınla',
                        'publish.cancel': 'İptal',
                        'publish.title': 'Başlık',
                        'publish.description': 'Açıklama',
                        'publish.listed': 'Listelensin',
                        'publish.failed': 'YAYINLAMA BAŞARISIZ',
                        'publish.please-try-again': 'Lütfen daha sonra tekrar deneyin.',
                        'publish.succeeded': 'YAYINLANDI',
                        'publish.message': 'Sahnenize erişmek için aşağıdaki bağlantıyı kullanın.',
                        'publish.please-log-in': 'PlayCanvas’a yayınlamak için kullanıcı hesabı gerekir. Lütfen oturum açıp yeniden deneyin.',
                        'publish.converting': 'Dönüştürülüyor...',
                        'publish.uploading': 'Yükleniyor...',

                        // Image Settings Dialog
                        'image.header': 'GÖRSEL AYARLARI',
                        'image.preset': 'Hazır Ayar',
                        'image.resolution': 'Çözünürlük',
                        'image.transparentBg': 'Saydam Arka Plan',
                        'image.showDebug': 'Hata Ayıklama Katmanlarını Göster',
                        'image.resolutionCurrent': 'Geçerli',
                        'image.resolutionCustom': 'Özel',

                        // Video Settings Dialog
                        'video.header': 'VİDEO AYARLARI',
                        'video.resolution': 'Çözünürlük',
                        'video.frameRate': 'Kare Hızı',
                        'video.bitrate': 'Bit Hızı',
                        'video.portrait': 'Dikey Mod',
                        'video.transparentBg': 'Saydam Arka Plan',
                        'video.showDebug': 'Hata Ayıklama Katmanlarını Göster',

                        // Timeline
                        'timeline.prev-key': 'Önceki anahtar kareye atla',
                        'timeline.play': 'Oynat/Durdur',
                        'timeline.next-key': 'Sonraki anahtar kareye atla',
                        'timeline.add-key': 'Anahtar Ekle',
                        'timeline.remove-key': 'Anahtarı Kaldır',
                        'timeline.frame-rate': 'Kare Hızı',
                        'timeline.total-frames': 'Toplam Kare',

                        // Image Viewer Panel
                        'image-viewer': 'Resim Görüntüleyici',

                        // Image Import
                        'image.import': 'Görselleri içe aktar',
                        'image-config.import': 'Görüntü yapılandırmasını içe aktar',

                        // User
                        'user.login': 'Giriş',
                        'user.logout': 'Çıkış',
                        'user.scenes': 'Olay yerleri',
                        'user.account': 'Hesap',
                        'user.email': 'E-posta/Kullanıcı adı',
                        'user.password': 'Şifre',
                        'user.invalid-credentials': 'Geçersiz e-posta veya şifre.',
                        'user.login-failed': 'Giriş başarısız. Lütfen tekrar deneyin.',
                        'user.scenes.header': 'OLAY YERLERİ',
                        'user.scenes.upload': 'Yeni Olay Yeri Yükle',
                        'user.scenes.download': 'İndir',
                        'user.upload.header': 'OLAY YERİ YÜKLE',
                        'user.upload.photos': 'Fotoğraflar',
                        'user.upload.video': 'Video',
                        'user.upload.photos-desc': 'Olay yeri oluşturma için birden fazla fotoğraf seçin.',
                        'user.upload.video-desc': 'Olay yeri oluşturma için tek bir video dosyası seçin.',
                        'user.upload.drop-files': 'Dosyaları sürükleyip bırakın veya seçmek için tıklayın',
                        'user.upload.pick-files': 'Dosyaları Seç',
                        'user.upload.project-name': 'Proje Adı',
                        'user.upload.error-no-files': 'Lütfen en az bir dosya seçin.',
                        'user.upload.error-no-name': 'Lütfen bir proje adı girin.',
                        'user.upload.error-mixed': 'Fotoğraf ve videoları birlikte yükleyemezsiniz.',
                        'user.upload.error-multiple-videos': 'Aynı anda yalnızca bir video yüklenebilir.',

                        // Delil
                        'evidence.evidence': 'Delil',
                        'evidence.focus': 'Odakla',
                        'evidence.add-photo': '+ Resim',
                        'evidence.name': 'İsim',
                        'evidence.name-box': 'Delil ismi...',
                        'evidence.position': 'Pozisyon',
                        'evidence.use-camera-focus': '📍 Kamera odağını kullan',
                        'evidence.use-camera-focus-extend': 'İşareti 3B düzlemde hareket ettirerek odağı ayarlayabilirsiniz',
                        'evidence.size': 'Boyut (yarı ölçü)',
                        'evidence.photos': 'Fotoğraflar',
                        'evidence.add-photo-button': '+ Fotoğraf Ekle',
                        'evidence.create-evidence': 'Delil Oluştur',
                        'evidence.cancel': 'İptal',
                        'evidence.add-new-evidence': 'Yeni delil ekle',
                        'evidence.images': 'resim',
                        'evidence.new-evidence': '(yeni delil)',
                        'evidence.remove': 'Sil',
                        'evidence.remove-evidence': 'Delili sil',
                        'evidence.removal-approve': '\"{{label0}}\" silinsin mi? Bu işlem geri alınamaz.',
                        'evidence.no-evidence-found': 'Sahnede delil bulunamadı. +\'ya basarak yeni delil ekleyebilirsiniz.'
                    }
                },
                'zh-CN': {
                    translation: {
                        // File menu
                        'file': '文件',
                        'file.new': '新建',
                        'file.open': '打开',
                        'file.import': '导入...',
                        'file.load-all-data': '加载所有 PLY 数据',
                        'file.save': '保存',
                        'file.save-as': '另存为...',
                        'file.publish': '发布...',
                        'file.export': '导出',
                        'file.export.splat': 'Splat 文件',
                        'file.export.viewer': '查看器应用...',
                        'download.reference.pdf': '下载参考 PDF',

                        // Render menu
                        'render': '渲染',
                        'render.image': '图像...',
                        'render.video': '视频...',
                        'render.ok': '渲染',
                        'render.cancel': '取消',

                        // Selection menu
                        'select': '选择',
                        'select.all': '全部',
                        'select.none': '无',
                        'select.invert': '反选',
                        'select.lock': '锁定选择',
                        'select.unlock': '解锁全部',
                        'select.delete': '删除选择',
                        'select.reset': '重置 Splat',
                        'select.duplicate': '复制',
                        'select.separate': '分离',

                        // Help menu
                        'help': '帮助',
                        'help.shortcuts': '键盘快捷键',
                        'help.user-guide': '用户指南',
                        'help.log-issue': '报告问题',
                        'help.github-repo': 'GitHub 仓库',
                        'help.basics-video': '基础视频',
                        'help.discord': 'Discord 服务器',
                        'help.forum': '论坛',
                        'help.about': '关于 Biligoba Scene Forensics',

                        // Modes
                        'mode.centers': '中心模式',
                        'mode.rings': '环模式',

                        // Scene panel
                        'scene-manager': '场景管理器',
                        'transform': '变换',
                        'position': '位置',
                        'rotation': '旋转',
                        'scale': '缩放',

                        // Options panel
                        'options': '视图选项',
                        'options.colors': '颜色',
                        'options.bg-color': '背景颜色',
                        'options.selected-color': '选中颜色',
                        'options.unselected-color': '未选中颜色',
                        'options.locked-color': '锁定颜色',
                        'options.fov': '视野角',
                        'options.sh-bands': 'SH 带',
                        'options.centers-size': '中心大小',
                        'options.outline-selection': '轮廓选择',
                        'options.show-grid': '显示网格',
                        'options.show-bound': '显示边界',
                        'options.camera-fly-speed': '相机速度',
                        'options.high-precision': '高质量',

                        // Camera panel
                        'camera': '相机姿势',
                        'camera.add-pose': '添加姿势',
                        'camera.prev-pose': '上一个姿势',
                        'camera.next-pose': '下一个姿势',
                        'camera.play-poses': '播放姿势',
                        'camera.clear-poses': '清除姿势',

                        // Color panel
                        'colors': '颜色',
                        'colors.tint': '色调',
                        'colors.temperature': '温度',
                        'colors.saturation': '饱和度',
                        'colors.brightness': '亮度',
                        'colors.blackPoint': '黑点',
                        'colors.whitePoint': '白点',
                        'colors.transparency': '透明度',
                        'colors.reset': '重置',

                        // Data panel
                        'data': 'SPLAT 数据',
                        'data.distance': '距离',
                        'data.volume': '体积',
                        'data.surface-area': '表面积',
                        'data.scale-x': '缩放 X',
                        'data.scale-y': '缩放 Y',
                        'data.scale-z': '缩放 Z',
                        'data.red': '红',
                        'data.green': '绿',
                        'data.blue': '蓝',
                        'data.opacity': '不透明度',
                        'data.hue': '色相',
                        'data.saturation': '饱和度',
                        'data.value': '明度',
                        'data.log-scale': '对数缩放',
                        'data.totals': '总计',
                        'data.totals.splats': 'Splat',
                        'data.totals.selected': '选择',
                        'data.totals.locked': '锁定',
                        'data.totals.deleted': '删除',

                        // Shortcuts panel
                        'shortcuts.title': '键盘快捷键',
                        'shortcuts.movement': '移动',
                        'shortcuts.move-forward': '前进',
                        'shortcuts.move-backward': '后退',
                        'shortcuts.move-left': '左移',
                        'shortcuts.move-right': '右移',
                        'shortcuts.move-up': '上移',
                        'shortcuts.move-down': '下移',
                        'shortcuts.move-fast': '快速移动 (10x)',
                        'shortcuts.move-slow': '慢速移动 (0.1x)',
                        'shortcuts.camera': '相机',
                        'shortcuts.zoom': '缩放',
                        'shortcuts.pan': '平移',
                        'shortcuts.zoom-fast': '快速缩放',
                        'shortcuts.orbit': '旋转相机',
                        'shortcuts.focus-point': '设置焦点',
                        'shortcuts.tools': '工具',
                        'shortcuts.move': '移动',
                        'shortcuts.rotate': '旋转',
                        'shortcuts.scale': '缩放',
                        'shortcuts.rect-selection': '矩形选择',
                        'shortcuts.brush-selection': '画笔选择',
                        'shortcuts.picker-selection': '拾取选择',
                        'shortcuts.brush-size': '减小/增大画笔大小',
                        'shortcuts.deactivate-tool': '停用工具',
                        'shortcuts.selection': '选择',
                        'shortcuts.select-all': '全选',
                        'shortcuts.deselect-all': '取消全选',
                        'shortcuts.invert-selection': '反选',
                        'shortcuts.add-to-selection': '添加到选择',
                        'shortcuts.remove-from-selection': '从选择中移除',
                        'shortcuts.delete-selected-splats': '删除选择的 Splat',
                        'shortcuts.show': '显示',
                        'shortcuts.hide-selected-splats': '隐藏选择的 Splat',
                        'shortcuts.unhide-all-splats': '显示全部 Splat',
                        'shortcuts.toggle-data-panel': '切换数据面板',
                        'shortcuts.other': '其他',
                        'shortcuts.select-next-splat': '选择下一个 Splat',
                        'shortcuts.undo': '撤销',
                        'shortcuts.redo': '重做',
                        'shortcuts.toggle-splat-overlay': '切换 Splat 叠加',
                        'shortcuts.focus-camera': '聚焦当前选择',
                        'shortcuts.toggle-camera-mode': '切换相机模式',
                        'shortcuts.toggle-grid': '切换网格',
                        'shortcuts.toggle-gizmo-coordinate-space': '切换 Gizmo 坐标空间',

                        // Popup
                        'popup.ok': '确定',
                        'popup.cancel': '取消',
                        'popup.yes': '是',
                        'popup.no': '否',
                        'popup.error': '错误',
                        'popup.error-loading': '加载文件错误',
                        'popup.drop-files': '请拖放文件和文件夹',
                        'popup.copy-to-clipboard': '复制链接到剪贴板',

                        // Right toolbar
                        'tooltip.splat-mode': 'Splat 模式 ( M )',
                        'tooltip.show-hide': '显示/隐藏 Splats ( Space )',
                        'tooltip.frame-selection': '框选 ( F )',
                        'tooltip.camera-reset': '重置相机',
                        'tooltip.color-panel': '颜色',
                        'tooltip.view-options': '视图选项',
                        'tooltip.clickable-zones': '证据',
                        'tooltip.evidence-list': '证据列表',
                        'tooltip.show-associated-picture': '显示相关图片',

                        // Bottom toolbar
                        'tooltip.undo': '撤销 ( Ctrl + Z )',
                        'tooltip.redo': '重做 ( Ctrl + Shift + Z )',
                        'tooltip.picker': '选择器 ( R )',
                        'tooltip.polygon': '多边形选择 ( P )',
                        'tooltip.brush': '画笔 ( B )',
                        'tooltip.sphere': '球选择',
                        'tooltip.box': '盒选择',
                        'tooltip.translate': '移动 ( 1 )',
                        'tooltip.rotate': '旋转 ( 2 )',
                        'tooltip.scale': '缩放 ( 3 )',
                        'tooltip.local-space': '局部坐标系',
                        'tooltip.bound-center': '使用边界中心',
                        'tooltip.measure-distance': '测距',

                        // Measure Tool
                        'measure.distance': '距离',

                        // Viewer Export
                        'export.header': '导出',
                        'export.type': '导出类型',
                        'export.html': 'HTML',
                        'export.package': 'ZIP 包',
                        'export.sh-bands': 'SH 带',
                        'export.start-position': '起始位置',
                        'export.default': '默认',
                        'export.viewport': '当前视口',
                        'export.pose-camera': '第一个相机姿势',
                        'export.fov': '视野角',
                        'export.background-color': '背景颜色',
                        'export.filename': '文件名',
                        'export.animation': '动画',
                        'export.animation-none': '无',
                        'export.animation-track': '轨道',
                        'export.ply-compress': '压缩PLY',
                        'export.splats-select': 'Splat',
                        'export.splats-select.all': '所有Splat',
                        'export.format': '文件格式',
                        'export.format-compressed-ply': '压缩 PLY',
                        'export.format-sogs': 'SOGS',

                        // Cursor
                        'cursor.click-to-copy': '点击复制',
                        'cursor.copied': '已复制!',

                        // Doc
                        'doc.reset': '重置场景',
                        'doc.unsaved-message': '有未保存的更改。您确定要重置场景吗？',
                        'doc.reset-message': '您确定要重置场景吗？',
                        'doc.save-failed': '保存失败',
                        'doc.load-failed': '加载失败',

                        // Publish Settings Dialog
                        'publish.header': '发布设置',
                        'publish.ok': '发布',
                        'publish.cancel': '取消',
                        'publish.title': '标题',
                        'publish.description': '描述',
                        'publish.listed': '列出',
                        'publish.failed': '发布失败',
                        'publish.please-try-again': '请稍后再试。',
                        'publish.succeeded': '发布成功',
                        'publish.message': '请使用以下链接访问场景。',
                        'publish.please-log-in': '要在 PlayCanvas 上发布，需要用户帐户。请登录并重试。',

                        // Video Settings Dialog
                        'video.header': '视频设置',
                        'video.resolution': '分辨率',
                        'video.frameRate': '帧率',
                        'video.bitrate': '比特率',
                        'video.portrait': '纵向模式',
                        'video.transparentBg': '透明背景',
                        'video.showDebug': '显示调试覆盖',

                        // Timeline
                        'timeline.prev-key': '上一个关键帧',
                        'timeline.play': '播放/停止',
                        'timeline.next-key': '下一个关键帧',
                        'timeline.add-key': '添加关键帧',
                        'timeline.remove-key': '删除关键帧',
                        'timeline.frame-rate': '帧率',
                        'timeline.total-frames': '总帧数',

                        // Image Viewer Panel
                        'image-viewer': '图像查看器',

                        // Image Import
                        'image.import': '导入图像',
                        'image-config.import': '导入图像配置',
                        // User
                        'user.login': '登录',
                        'user.logout': '登出',
                        'user.scenes': '现场',
                        'user.account': '账户',
                        'user.email': '电子邮件/用户名',
                        'user.password': '密码',
                        'user.invalid-credentials': '无效的电子邮件或密码。',
                        'user.login-failed': '登录失败。请再试一次。',
                        'user.scenes.header': '远程场景',
                        'user.scenes.upload': '上传新场景',
                        'user.scenes.download': '下载',
                        'user.upload.header': '上传场景',
                        'user.upload.photos': '照片',
                        'user.upload.video': '视频',
                        'user.upload.photos-desc': '选择多张照片进行重建。',
                        'user.upload.video-desc': '选择单个视频文件进行重建。',
                        'user.upload.drop-files': '将文件拖到此处或点击选择',
                        'user.upload.pick-files': '选择文件',
                        'user.upload.project-name': '项目名称',
                        'user.upload.error-no-files': '请选择至少一个文件。',
                        'user.upload.error-no-name': '请输入项目名称。',
                        'user.upload.error-mixed': '您不能同时上传照片和视频。',
                        'user.upload.error-multiple-videos': '一次只能上传一个视频。'
                    }
                }
            },
            interpolation: {
                escapeValue: false
            }
        });
};

// Overload the function in order to handle parameters...
function localize(key: string): string;
function localize(key: string, options: Record<string, any>): string;

function localize(key: string, options?: Record<string, any>): string {
    return i18next.t(key, options) as string;
}

export { localizeInit, localize };
